import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import AxisModal from "../modal/AxisModal";
import StakesSection from "../stake/StakesSection";
import Loader from "../progress-bar/Loader";
import {deleteAxis, loadOneAxis} from "./one-axis/oneAxisAction";
import YesNoModal from "../modal/YesNoModal";
import styled from "styled-components";
import {loadAllAxis} from "./all-axis/axisAction";
import {CLEAR_ONE_AXIS} from "./actionTypes";
import TabContainer from "../tab/TabContainer";
import AxisList from "./AxisList";
import useTab from "../../custom-hooks/useTab";
import {STRATEGY_FILTER, UN_STRATEGY_FILTER} from "../tab/filterTypes";

const AxisSection = () => {
    const {isLoading, axis} = useSelector(state => state.axis)
    const [selectedAxisId, setSelectedAxisId] = useState(0)
    const [axisDisplayed, setAxisDisplayed] = useState([])
    const [openEditModal, setOpenEditModal] = useState(false)
    const [openDeleteModal, setOpenDeleteModal] = useState(false)

    const [openStakesView, setOpenStakeView] = useState(false)
    const [openCreateStakeModal, setOpenCreateStakeModal] = useState(false)
    const [openEditStakeModal, setOpenEditStakeModal] = useState(false)
    const [sectionsMenu, setSectionsMenu] = useState([])
    const {sections, toggleSection, activeTab} = useTab(sectionsMenu)

    const dispatch = useDispatch()


    useEffect(() => {
        setSectionsMenu([
            {key: STRATEGY_FILTER, label: "Stratégie", state: true},
            {key: UN_STRATEGY_FILTER, label: "Projets internes / Organisation", state: false}]
        )
    }, [])


    useEffect(() => {
        if (activeTab === 0) {
            setAxisDisplayed(axis.filter(a => a.isStrategic === true))
        }
        if (activeTab === 1) {
            setAxisDisplayed(axis.filter(a => a.isStrategic === false))
        }
    }, [activeTab, axis])

    useEffect(() => {
        setOpenStakeView(false);
    }, [activeTab])

    useEffect(() => {
        dispatch(loadAllAxis())
    }, [dispatch])


    const handleAxisViewOpening = (id, e) => {
        if (e.target.tagName === "svg" || e.target.tagName === "path") return
        if (selectedAxisId === id) {
            setSelectedAxisId(0)
            setOpenStakeView(false)
            dispatch({type: CLEAR_ONE_AXIS})
        } else {
            setSelectedAxisId(id)
            dispatch(loadOneAxis(id))
            setOpenStakeView(true)
        }
    }
    const deleteRequest = async (id) => {
        await dispatch(deleteAxis(id))
        dispatch(loadAllAxis())
        setOpenDeleteModal(false)
        setSelectedAxisId(0)
        if (openStakesView) {
            setOpenStakeView(false)
        }
    }

    const displayModals = () => {
        if (openEditModal) {
            return (
                <AxisModal
                    setOpenModal={setOpenEditModal}
                    selectedId={selectedAxisId}
                />
            )
        }
        if (openDeleteModal) {
            return (
                <YesNoModal
                    name={"l'axe (les enjeux seront aussi supprimés) ? Les projets seront déliés de cet axe et vous pourrez les retrouver dans le menu Projets. "}
                    setOpenModal={setOpenDeleteModal}
                    handleClickYesAction={deleteRequest}
                    id={selectedAxisId}
                />
            )
        }
    }


    return (
        <Container>
            {displayModals()}
            <TabContainer
                selectedTab={activeTab}
                children={sections}
                toggleSection={toggleSection}
            />
            {isLoading ?
                <Loader/>
                :
                <Wrapper>
                    <AxisList
                        openStakesView={openStakesView}
                        axis={axisDisplayed}
                        handleAxisViewOpening={handleAxisViewOpening}
                        setOpenDeleteModal={setOpenDeleteModal}
                        setOpenEditModal={setOpenEditModal}
                        setSelectedAxisId={setSelectedAxisId}
                        selectedAxisId={selectedAxisId}
                    />
                    {openStakesView &&
                    <StakesSection
                        setOpenStakeView={setOpenStakeView}
                        openStakesView={openStakesView}
                        openCreateStakeModal={openCreateStakeModal}
                        setOpenCreateStakeModal={setOpenCreateStakeModal}
                        openEditStakeModal={openEditStakeModal}
                        setOpenEditStakeModal={setOpenEditStakeModal}
                    />
                    }
                </Wrapper>
            }

        </Container>
    )
}


const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 100%;
  justify-content: flex-start;
  align-items: center;
  gap: 1rem;

  h1 {
    width: 100%;
    text-align: center;
  }

  @media (min-width: 900px) {
    height: initial;
    width: 100%;
    h1 {
      width: 100%;
      text-align: center;
    }
  }
`
const Wrapper = styled.div`
  padding: 1em 0;
  margin: 1em 0;
  display: flex;
  flex-wrap: wrap;
  flex-grow: 0.5;
  gap: 2rem;
  align-items: center;
  justify-content: center;
  width: 100%;
  overflow: hidden;
  @media (min-width: 900px) {
    width: 100%;
    flex-direction: row;
    align-items: flex-start;
    flex-wrap: nowrap;
    margin: 0;
    .container-active {
      display: grid;
      grid-template-columns: repeat(2, 45%);
      width: 50%;
    }
  }
`

export default AxisSection;